import { render, staticRenderFns } from "./StudentClassProjectionCoordinator.vue?vue&type=template&id=f2920b02"
import script from "./StudentClassProjectionCoordinator.vue?vue&type=script&lang=js"
export * from "./StudentClassProjectionCoordinator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports